import React, {
  useMemo,
  useState,
} from "react";

import "./InviteCode.css";

import {
  FaWhatsapp,
  FaTelegramPlane,
  FaQrcode,
  FaShareAlt,
  FaFacebook,
  FaInstagram,
  FaCopy,
  FaCheck,
  FaArrowLeft,
  FaLink,
  FaUsers,
} from "react-icons/fa";

import { MdContacts } from "react-icons/md";

import { useNavigate } from "react-router-dom";


export default function InviteCode() {

  const navigate = useNavigate();

  const [copied, setCopied] =
    useState("");


  /* =========================================================
     USER
  ========================================================= */

  const user = useMemo(() => {

    try {

      return JSON.parse(
        localStorage.getItem(
          "user"
        ) || "{}"
      );

    } catch (error) {

      console.error(
        "Failed reading user:",
        error
      );

      return {};

    }

  }, []);


  /* =========================================================
     REFERRAL DATA
  ========================================================= */

  const referralCode =
    user?.referralCode ||
    "no-code";


  const referralLink =
    user?.referralLink ||
    `https://bfctrade.cc/register?ref=${referralCode}`;


  /* =========================================================
     COPY
  ========================================================= */

  const handleCopy = async (
    text,
    type
  ) => {

    try {

      if (
        navigator.clipboard &&
        window.isSecureContext
      ) {

        await navigator.clipboard.writeText(
          text
        );

      } else {

        const textArea =
          document.createElement(
            "textarea"
          );

        textArea.value =
          text;

        textArea.style.position =
          "fixed";

        textArea.style.left =
          "-9999px";

        textArea.style.top =
          "0";

        textArea.style.opacity =
          "0";

        document.body.appendChild(
          textArea
        );

        textArea.focus();

        textArea.select();

        document.execCommand(
          "copy"
        );

        document.body.removeChild(
          textArea
        );

      }


      setCopied(type);


      setTimeout(() => {

        setCopied("");

      }, 2200);


    } catch (error) {

      console.error(
        "Copy failed:",
        error
      );

      alert(
        "Failed to copy. Please try again."
      );

    }

  };


  /* =========================================================
     WHATSAPP
  ========================================================= */

  const shareWhatsApp = () => {

    const text =
      `Join me on ANT BET 🔥\n\n +`
      `Register using my referral link:\n +`
      `${referralLink}`;

    window.open(
      `https://wa.me/?text=${encodeURIComponent(
        text
      )}`,
      "_blank",
      "noopener,noreferrer"
    );

  };


  /* =========================================================
     TELEGRAM
  ========================================================= */

  const shareTelegram = () => {

    window.open(
      `https://t.me/share/url?url=${encodeURIComponent(
        referralLink
      )}&text=${encodeURIComponent(
        "Join me on ANT BET 🔥"
      )}`,
      "_blank",
      "noopener,noreferrer"
    );

  };


  /* =========================================================
     FACEBOOK
  ========================================================= */

  const shareFacebook = () => {

    window.open(
      `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(
        referralLink
      )}`,
      "_blank",
      "noopener,noreferrer"
    );

  };


  /* =========================================================
     CONTACTS
  ========================================================= */

  const shareContacts = () => {

    const text =
      `Join me on ANT BET 🔥\n +`
      `Register here:\n +`
      `${referralLink}`;

    window.open(
      `sms:?body=${encodeURIComponent(
        text
      )}`,
      "_blank"
    );

  };


  /* =========================================================
     INSTAGRAM
  ========================================================= */

  const shareInstagram = () => {

    handleCopy(
      referralLink,
      "instagram"
    );

  };


  /* =========================================================
     NATIVE SHARE
  ========================================================= */

  const shareMore = async () => {

    try {

      if (
        navigator.share
      ) {

        await navigator.share({

          title:
            "Join me on ANT BET 🔥",

          text:
            "Register through my referral link 👇",

          url:
            referralLink,

        });

      } else {

        await handleCopy(
          referralLink,
          "link"
        );

      }

    } catch (error) {

      if (
        error?.name !==
        "AbortError"
      ) {

        console.error(
          "Share failed:",
          error
        );

      }

    }

  };


  /* =========================================================
     QR CODE
     
     Hatumii qrcode.react.
     Inatumia QR image API moja kwa moja.
  ========================================================= */

  const qrCodeUrl =
    `https://api.qrserver.com/v1/create-qr-code/?size=300x300&margin=12&data=${encodeURIComponent(
      referralLink
    )}`;


  /* =========================================================
     RENDER
  ========================================================= */

  return (

    <div className="invite-page">


      {/* =====================================================
          HEADER
      ===================================================== */}

      <header className="invite-header">

        <button
          type="button"
          className="invite-back-btn"
          onClick={() =>
            navigate(-1)
          }
        >

          <FaArrowLeft />

          <span>
            Back
          </span>

        </button>


        <div className="invite-header-title">

          <div className="invite-header-icon">
            <FaUsers />
          </div>


          <div>

            <span>
              REFERRAL PROGRAM
            </span>

            <h1>
              Invite Friends
            </h1>

          </div>

        </div>

      </header>


      {/* =====================================================
          HERO
      ===================================================== */}

      <section className="invite-hero">

        <div className="invite-glow" />

        <div className="invite-hero-content">

          <div className="invite-small-badge">

            <span />

            EARN WITH REFERRALS

          </div>


          <h2>

            Invite your friends

            <br />

            <span>
              and earn together
            </span>

          </h2>


          <p>

            Share your referral link
            with friends and let them
            join ANT BET using your
            invitation.

          </p>

        </div>

      </section>


      {/* =====================================================
          REFERRAL LINK — FIRST
      ===================================================== */}

      <section className="invite-data-card">

        <div className="invite-card-top">

          <div className="invite-card-icon link-icon">

            <FaLink />

          </div>


          <div>

            <span>
              REFERRAL LINK
            </span>

            <h3>
              Your Invitation Link
            </h3>

          </div>

        </div>


        <div className="invite-link-box">

          <div className="invite-link-content">

            <span>
              {referralLink}
            </span>

          </div>


          <button
            type="button"
            onClick={() =>
              handleCopy(
                referralLink,
                "link"
              )
            }
          >

            {copied === "link" ? (

              <>
                <FaCheck />

                <span>
                  Copied
                </span>
              </>

            ) : (

              <>
                <FaCopy />

                <span>
                  Copy
                </span>
              </>

            )}

          </button>

        </div>

      </section>


      {/* =====================================================
          REFERRAL CODE — SECOND
      ===================================================== */}

      <section className="invite-data-card">

        <div className="invite-card-top">

          <div className="invite-card-icon code-icon">

            <FaUsers />

          </div>


          <div>

            <span>
              REFERRAL CODE
            </span>

            <h3>
              Your Code
            </h3>

          </div>

        </div>


        <div className="invite-code-box">

          <strong>
            {referralCode}
          </strong>


          <button
            type="button"
            onClick={() =>
              handleCopy(
                referralCode,
                "code"
              )
            }
          >

            {copied === "code" ? (

              <>
                <FaCheck />

                <span>
                  Copied
                </span>
              </>

            ) : (

              <>
                <FaCopy />

                <span>
                  Copy
                </span>
              </>

            )}

          </button>

        </div>

      </section>


      {/* =====================================================
          QR CODE — THIRD
      ===================================================== */}

      <section className="invite-qr-card">

        <div className="invite-qr-header">

          <div>

            <span>
              SCAN TO JOIN
            </span>

            <h3>
              Your QR Code
            </h3>

          </div>


          <div className="invite-qr-icon">

            <FaQrcode />

          </div>

        </div>


        <div className="invite-qr-wrapper">

          <div className="invite-qr-frame">

            <img
              src={qrCodeUrl}
              alt="Referral QR Code"
              className="referral-qr"
            />

          </div>

        </div>


        <p className="invite-qr-text">

          Scan this QR code to
          register using your
          referral link.

        </p>

      </section>


      {/* =====================================================
          SHARE
      ===================================================== */}

      <section className="invite-share-section">

        <div className="invite-section-heading">

          <span>
            SHARE YOUR LINK
          </span>

          <h2>
            Invite via
          </h2>

        </div>


        <div className="invite-share-grid">


          {/* CONTACT */}

          <button
            type="button"
            className="invite-share-item"
            onClick={
              shareContacts
            }
          >

            <div className="share-icon contact">

              <MdContacts />

            </div>

            <span>
              Contacts
            </span>

          </button>


          {/* WHATSAPP */}

          <button
            type="button"
            className="invite-share-item"
            onClick={
              shareWhatsApp
            }
          >

            <div className="share-icon whatsapp">

              <FaWhatsapp />

            </div>

            <span>
              WhatsApp
            </span>

          </button>


          {/* TELEGRAM */}

          <button
            type="button"
            className="invite-share-item"
            onClick={
              shareTelegram
            }
          >

            <div className="share-icon telegram">

              <FaTelegramPlane />

            </div>

            <span>
              Telegram
            </span>

          </button>


          {/* FACEBOOK */}

          <button
            type="button"
            className="invite-share-item"
            onClick={
              shareFacebook
            }
          >

            <div className="share-icon facebook">

              <FaFacebook />

            </div>

            <span>
              Facebook
            </span>

          </button>


          {/* INSTAGRAM */}

          <button
            type="button"
            className="invite-share-item"
            onClick={
              shareInstagram
            }
          >

            <div className="share-icon instagram">

              <FaInstagram />

            </div>

            <span>
              Instagram
            </span>

          </button>


          {/* QR */}

          <button
            type="button"
            className="invite-share-item"
            onClick={() =>
              document
                .querySelector(
                  ".invite-qr-card"
                )
                ?.scrollIntoView({
                  behavior:
                    "smooth",
                  block:
                    "center",
                })
            }
          >

            <div className="share-icon qr">

              <FaQrcode />

            </div>

            <span>
              QR Code
            </span>

          </button>


          {/* MORE */}

          <button
            type="button"
            className="invite-share-item"
            onClick={
              shareMore
            }
          >

            <div className="share-icon more">

              <FaShareAlt />

            </div>

            <span>
              More
            </span>

          </button>

        </div>

      </section>


      {/* =====================================================
          FOOTER INFO
      ===================================================== */}

      <section className="invite-info">

        <div className="invite-info-icon">
          🔥
        </div>


        <div>

          <strong>
            Start inviting today
          </strong>

          <p>
            Share your code or link
            with friends and grow
            your referral network.
          </p>

        </div>

      </section>


    </div>

  );

}


